import React, { useContext, useState } from "react";
import "../account.css";
import "./accountFAQ.css";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";
import { ChevronDown, HelpCircle } from "lucide-react";

const AccountFAQ = () => {
    const { language } = useContext(CombinedContext);
    const t = translations[language].account.faq;

    const [openIndex, setOpenIndex] = useState(null);

    const toggle = (i) => setOpenIndex((prev) => (prev === i ? null : i));

    return (
        <div className="ac-page apf">
            <header className="ac-head">
                {/* <span className="ac-eyebrow">{t.sectionLabel}</span> */}
                <h1 className="ac-title">{t.title}</h1>
            </header>

            <section className="ac-card">
                <div className="ac-card-head">
                    <span className="ac-icon">
                        <HelpCircle size={16} />
                    </span>
                    <h3>{t.sectionLabel}</h3>
                    <span className="ac-badge ac-badge--neutral">{t.items.length}</span>
                </div>

                <div className="ac-card-body is-flush">
                    {t.items.map((item, i) => {
                        const isOpen = openIndex === i;

                        return (
                            <div key={i} className={`apf-item ${isOpen ? "is-open" : ""}`}>
                                <button className="apf-question" onClick={() => toggle(i)} aria-expanded={isOpen}>
                                    <span>{item.question}</span>
                                    <ChevronDown size={18} className="apf-chevron" />
                                </button>

                                {/* grid-rows collapse — animates to the answer's real height */}
                                <div className={`apf-answer ${isOpen ? "is-open" : ""}`}>
                                    <div>
                                        <div className="apf-answer-inner">
                                            {item.answer && <p>{item.answer}</p>}
                                            {item.list && (
                                                <ol className="apf-steps">
                                                    {item.list.map((li, j) => (
                                                        <li key={j}>{li}</li>
                                                    ))}
                                                </ol>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </section>
        </div>
    );
};

export default AccountFAQ;
